// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.tryitouteditor {
  border-radius: 4px;
  overflow: hidden;
  position: relative;
}

.tryitouteditor ngx-monaco-editor {
  width: 100%;
  height: 58vh;
  position: relative;
  right: 16px;
}

.example-tree-invisible {
  display: none;
}

.example-tree ul,
.example-tree li {
  margin-top: 0;
  margin-bottom: 0;
  list-style-type: none;
}

.textColor {
  color: green;
}

.mat-tree-node {
  min-height: 1px;
  align-items: flex-start;
}

.mat-icon-button {
  height: 1px;
  width: 20px;
}

.mat-icon-rtl-mirror {
  vertical-align: top;
}

.accession_field {
  height: 28px !important;
  margin-left: 3%;
  padding-left: 2%;
  font-size: 12px !important;
}

.accession_field::placeholder {
  font-size: 12px !important;
}

.field_droping {
  width: 100%;
  margin-left: 4%;
  box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.2), 0 1px 1px 0 rgba(0, 0, 0, 0.14), 0 2px 1px -1px rgba(0, 0, 0, 0.12);
  border-radius: 5px;
  padding-inline: 1%;
  top: -3px;
  background-color: rgb(255, 255, 255);
  left: -5px;
  height: 32px;
}

::ng-deep .field_droping .mat-form-field-wrapper {
  padding-bottom: 0 !important;
}

::ng-deep .field_droping .mat-form-field-flex {
  padding: 0 !important;
}

.mod_header {
  padding-inline: 1%;
  background-color: #17a0b4 !important;
  padding-block: 5px;
  font-size: 12px !important;
  color: white;
}

.Template_dropDown {
  height: 32px;
  border-radius: 5px;
  padding-inline: 1%;
  position: relative;
  top: 1%;
  background-color: white;
  margin-left: 1px;
  margin-right: 2%;
  margin-block: 1%;
}

::ng-deep.Template_dropDown .mat-form-field-infix {
  border: 0 !important;
  height: 33px !important;
  font-size: 13px;
}

::ng-deep.Template_dropDown .mat-form-field-appearance-outline .mat-form-field-wrapper {
  padding: 1%;
  margin: 1%;
}

::ng-deep.Template_dropDown .mat-form-field-label-wrapper {
  top: -1px !important;
}

::ng-deep.Template_dropDown .mat-select-trigger {
  min-width: 10vw;
}

.mat_selection {
  margin-left: 4%;
  margin-bottom: 4%;
  height: 35px;
  border-radius: 5px;
  padding-inline: 1%;
  padding-bottom: 1%;
}

::ng-deep.mat_selection .mat-form-field-infix {
  border: 0 !important;
  height: 33px !important;
  font-size: 13px;
}

::ng-deep.mat_selection .mat-form-field-appearance-outline .mat-form-field-wrapper {
  padding: 1%;
  margin: 1%;
}

::ng-deep.mat-selection_label .mat-form-field-label-wrapper {
  position: absolute !important;
  top: 1px !important;
}

::ng-deep.mat-selection_label .mat-form-field-infix {
  border: 0 !important;
  height: 33px !important;
  font-size: 13px;
}

::ng-deep.selection_label .mat-form-field-appearance-outline .mat-form-field-wrapper {
  padding: 1%;
  margin: 1%;
}

::ng-deep.selection_label .mat-select-trigger {
  min-width: 10vw;
}

::ng-deep.path_class {
  width: 100%;
}

::ng-deep.pushmodal .modal-dialog {
  max-width: 50% !important;
  max-height: 60% !important;
  height: 60% !important;
  margin: auto !important;
  padding: 0 !important;
}

::ng-deep.pushmodal {
  top: 4% !important;
}

.ellipsisfull {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  /* width: 100% !important; */
  max-width: 90%;
}

::ng-deep .field_droping .mat-form-field-appearance-outline.mat-form-field-can-float.mat-form-field-should-float .mat-form-field-label {
  margin-left: 8px !important;
}

::ng-deep .field_droping .mat-form-field-appearance-outline .mat-form-field-infix {
  padding: 3px 7px !important;
}

::ng-deep.Version_dropDowns .mat-form-field-wrapper .mat-form-field-flex .mat-form-field-infix .mat-select .mat-select-trigger .mat-select-value {
  width: 65% !important;
}

.Version_dropDowns {
  height: 32px;
  border-radius: 5px;
  position: relative;
  top: -7px;
  background-color: white;
  margin-block: 1%;
  padding-left: 5px;
  width: 60%;
}

::ng-deep.Version_dropDowns .mat-form-field-infix {
  border: 0 !important;
  height: 33px !important;
  font-size: 13px;
}

::ng-deep.Version_dropDowns .mat-form-field-appearance-outline .mat-form-field-wrapper {
  padding: 1%;
  margin: 1%;
}

::ng-deep.Version_dropDowns .mat-form-field-label-wrapper {
  top: -1px !important;
}

::ng-deep.Version_dropDowns .mat-select-trigger {
  min-width: 13vw !important;
}

::ng-deep.Version_dropDowns .mat-select-arrow {
  position: relative !important;
  right: 47% !important;
}

::ng-deep.myCustomModalViewfilehl7Viewer .modal-dialog {
  max-width: 80% !important;
  max-height: 60% !important;
  height: 60% !important;
  padding: 0 !important;
  display: flex !important;
  justify-content: center !important;
}

::ng-deep.matoutlinestyles.versionfield {
  width: 70% !important;
}
::ng-deep.matoutlinestyles.versionfield .mat-mdc-text-field-wrapper {
  padding-block: 0px !important;
}

::ng-deep .rule-engine-tabs.mat-mdc-tab-group.mat-mdc-tab-group-stretch-tabs > .mat-mdc-tab-header .mat-mdc-tab {
  flex-grow: 0;
}

::ng-deep .rule-engine-tabs .mat-mdc-tab {
  background-color: white;
}

::ng-deep .rule-engine-tabs .mat-mdc-tab.mat-mdc-tab-active {
  background-color: white;
}

::ng-deep .rule-engine-tabs .mat-mdc-tab-label-container {
  background-color: white !important;
}

.qualified-routes-list {
  margin-top: 20px;
}

.qualified-routes-list ul {
  list-style-type: none;
  padding: 0;
}

.qualified-routes-list .route-item {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 5px 10px;
  border: 1px solid #ccc;
  border-radius: 4px;
  margin-bottom: 5px;
}

.qualified-routes-list .route-item:hover {
  background-color: #e3eaec;
}

.scrollable-output {
  overflow-y: auto;
  height: 52vh;
  width: 90vh;
  padding-right: 10px;
  font-size: 12px;
  margin-top: 25px;
}

.scrollable-routes {
  overflow-y: auto;
  padding: 10px;
}

.Ruleengineasterisk {
  font-size: 7px;
  position: absolute;
  color: rgba(244, 68, 85, 0.768627451) !important;
}`, "",{"version":3,"sources":["webpack://./src/app/rule-engine-try-it-out/rule-engine-try-it-out.component.scss","webpack://./src/variables.scss"],"names":[],"mappings":"AAEA;EAEE,kBAAA;EACA,gBAAA;EACA,kBAAA;AAFF;;AAKA;EACE,WAAA;EACA,YAAA;EACA,kBAAA;EACA,WAAA;AAFF;;AAIA;EACE,aAAA;AADF;;AAIA;;EAEE,aAAA;EACA,gBAAA;EACA,qBAAA;AADF;;AAGA;EACE,YAAA;AAAF;;AAEA;EACE,eAAA;EACA,uBAAA;AACF;;AACA;EACE,WAAA;EACA,WAAA;AAEF;;AAEA;EACE,mBAAA;AACF;;AA+BA;EACE,uBCrEU;EDsEV,eAAA;EACA,gBAAA;EACA,0BC1ES;AD8CX;;AA8BA;EACE,0BC7ES;ADkDX;;AA6BA;EACE,WAAA;EACE,eAAA;EACA,+GAAA;EACA,kBAAA;EACA,kBAAA;EACA,SAAA;EACA,oCAAA;EACA,UAAA;EACA,YAAA;AA1BJ;;AA4BC;EACC,4BAAA;AAzBF;;AA2BA;EACE,qBAAA;AAxBF;;AA4BA;EACE,kBAAA;EACA,oCCrGU;EDsGV,kBAAA;EACA,0BCtGS;EDuGT,YAAA;AAzBF;;AA4BA;EACE,YAAA;EACA,kBAAA;EACA,kBAAA;EACA,kBAAA;EACA,OAAA;EACA,uBAAA;EACA,gBAAA;EACA,gBAAA;EACA,gBAAA;AAzBF;;AA2BA;EACE,oBAAA;EACA,uBAAA;EACA,eAAA;AAxBF;;AA0BA;EACE,WAAA;EACA,UAAA;AAvBF;;AAyBA;EACE,oBAAA;AAtBF;;AAwBA;EACE,eAAA;AArBF;;AAuBA;EAEE,eAAA;EACA,iBAAA;EACA,YAAA;EAEA,kBAAA;EACA,kBAAA;EACA,kBAAA;AAtBF;;AAwBA;EACE,oBAAA;EACA,uBAAA;EACA,eAAA;AArBF;;AAuBA;EACE,WAAA;EACA,UAAA;AApBF;;AAsBA;EACE,6BAAA;EACA,mBAAA;AAnBF;;AAqBA;EACE,oBAAA;EACA,uBAAA;EACA,eAAA;AAlBF;;AAoBA;EACE,WAAA;EACA,UAAA;AAjBF;;AAoBA;EACE,eAAA;AAjBF;;AAmBA;EACI,WAAA;AAhBJ;;AAoBA;EACE,yBAAA;EACA,0BAAA;EACA,sBAAA;EACA,uBAAA;EACA,qBAAA;AAjBF;;AAmBA;EACE,kBAAA;AAhBF;;AAmBA;EACE,mBAAA;EACA,gBAAA;EACA,uBAAA;EACA,4BAAA;EACA,cAAA;AAhBF;;AAmBA;EACE,2BAAA;AAhBF;;AAmBA;EACE,2BAAA;AAhBF;;AAoBA;EACE,qBAAA;AAjBF;;AAmBA;EACE,YAAA;EACA,kBAAA;EACA,kBAAA;EACA,SAAA;EACA,uBAAA;EACA,gBAAA;EACA,iBAAA;EACA,UAAA;AAhBF;;AAkBA;EACE,oBAAA;EACA,uBAAA;EACA,eAAA;AAfF;;AAiBA;EACE,WAAA;EACA,UAAA;AAdF;;AAgBA;EACE,oBAAA;AAbF;;AAeA;EACE,0BAAA;AAZF;;AAcA;EACE,6BAAA;EACA,qBAAA;AAXF;;AAeA;EACE,yBAAA;EACA,0BAAA;EACA,sBAAA;EACA,qBAAA;EACA,wBAAA;EAAyB,kCAAA;AAX3B;;AAaA;EAEE,qBAAA;AAXF;AAYE;EACE,6BAAA;AAVJ;;AAcA;EACI,YAAA;AAXJ;;AAeE;EACE,uBAAA;AAZJ;;AAeE;EACE,uBAAA;AAZJ;;AAeE;EACE,kCAAA;AAZJ;;AAeA;EACE,gBAAA;AAZF;;AAeA;EACE,qBAAA;EACA,UAAA;AAZF;;AAeA;EACE,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,iBAAA;EACA,sBAAA;EACA,kBAAA;EACA,kBAAA;AAZF;;AAeA;EACE,yBAAA;AAZF;;AAeA;EACE,gBAAA;EACA,YAAA;EACA,WAAA;EACA,mBAAA;EACA,eAAA;EACA,gBAAA;AAZF;;AAcA;EACE,gBAAA;EACA,aAAA;AAXF;;AAcA;EACE,cAAA;EACA,kBAAA;EACA,gDAAA;AAXF","sourcesContent":["@import \"../../variables.scss\";\r\n\r\n.tryitouteditor {\r\n  //border: 1px solid #ccc;\r\n  border-radius: 4px;\r\n  overflow: hidden;\r\n  position: relative;\r\n}\r\n\r\n.tryitouteditor ngx-monaco-editor {\r\n  width: 100%;\r\n  height: 58vh;\r\n  position: relative;\r\n  right: 16px;\r\n}\r\n.example-tree-invisible {\r\n  display: none;\r\n}\r\n\r\n.example-tree ul,\r\n.example-tree li {\r\n  margin-top: 0;\r\n  margin-bottom: 0;\r\n  list-style-type: none;\r\n}\r\n.textColor{\r\n  color: green;;\r\n}\r\n.mat-tree-node {\r\n  min-height: 1px;\r\n  align-items: flex-start;\r\n}\r\n.mat-icon-button{\r\n  height:1px;\r\n  width: 20px;\r\n}\r\n\r\n\r\n.mat-icon-rtl-mirror{\r\n  vertical-align: top;\r\n}\r\n// ::ng-deep.autocomplete-container {\r\n//   box-shadow: 0 1px 3px 0 rgb(0 0 0 / 20%), 0 1px 1px 0 rgb(0 0 0 / 14%), 0 2px 1px -1px rgb(0 0 0 / 12%);\r\n//   position: relative;\r\n//   overflow: visible;\r\n//   height: 40px;\r\n//   border-radius: 5px;\r\n// }\r\n\r\n// ::ng-deep.autocomplete-container .input-container input{\r\n//   border-radius: 5px !important;\r\n//   padding-right: 12% !important;\r\n// }\r\n\r\n// .autocomplete-container {\r\n//   border-radius: 5px !important;\r\n// }\r\n// ::ng-deep.autocomplete-container .input-container .x i{\r\n//   font-weight: 600 !important;\r\n// }\r\n\r\n\r\n\r\n// ::ng-deep.pipeSearch .autocomplete-container {\r\n// height: 35px !important;\r\n// .input-container input{\r\n//   height: 35px !important;\r\n// }\r\n// }\r\n\r\n\r\n.accession_field{\r\n  height: $btnHeight;\r\n  margin-left: 3%;\r\n  padding-left: 2%;\r\n  font-size:$fontsize;\r\n}\r\n.accession_field::placeholder{\r\n  font-size: $fontsize;\r\n}\r\n.field_droping{\r\n  width: 100%;\r\n    margin-left: 4%;\r\n    box-shadow: 0 1px 3px 0 rgb(0 0 0 / 20%), 0 1px 1px 0 rgb(0 0 0 / 14%), 0 2px 1px -1px rgb(0 0 0 / 12%);\r\n    border-radius: 5px;\r\n    padding-inline: 1%;\r\n    top: -3px;\r\n    background-color: rgb(255, 255, 255);\r\n    left: -5px;\r\n    height: 32px;\r\n}\r\n ::ng-deep .field_droping .mat-form-field-wrapper {\r\n  padding-bottom: 0 !important;\r\n}\r\n::ng-deep .field_droping .mat-form-field-flex {\r\n  padding: 0 !important;\r\n}\r\n\r\n\r\n.mod_header{\r\n  padding-inline: 1%;\r\n  background-color:$btn-color;\r\n  padding-block: 5px;\r\n  font-size: $fontsize;\r\n  color:white;\r\n}\r\n\r\n.Template_dropDown{\r\n  height: 32px;\r\n  border-radius: 5px;\r\n  padding-inline: 1%;\r\n  position: relative;\r\n  top: 1%;\r\n  background-color: white;\r\n  margin-left: 1px;\r\n  margin-right: 2%;\r\n  margin-block: 1%;\r\n}\r\n::ng-deep.Template_dropDown  .mat-form-field-infix{\r\n  border: 0 !important;\r\n  height: 33px !important;\r\n  font-size: 13px;\r\n}\r\n::ng-deep.Template_dropDown .mat-form-field-appearance-outline .mat-form-field-wrapper{\r\n  padding: 1%;\r\n  margin: 1%;\r\n}\r\n::ng-deep.Template_dropDown .mat-form-field-label-wrapper{\r\n  top:-1px !important;\r\n}\r\n::ng-deep.Template_dropDown  .mat-select-trigger {\r\n  min-width: 10vw;\r\n}\r\n.mat_selection{\r\n  // width: 62%;\r\n  margin-left: 4%;\r\n  margin-bottom: 4%;\r\n  height: 35px;\r\n  // box-shadow: 0 1px 3px 0 rgb(0 0 0 / 20%), 0 1px 1px 0 rgb(0 0 0 / 14%), 0 2px 1px -1px rgb(0 0 0 / 12%);\r\n  border-radius: 5px;\r\n  padding-inline: 1%;\r\n  padding-bottom: 1%;\r\n}\r\n::ng-deep.mat_selection  .mat-form-field-infix{\r\n  border: 0 !important;\r\n  height: 33px !important;\r\n  font-size: 13px;\r\n}\r\n::ng-deep.mat_selection .mat-form-field-appearance-outline .mat-form-field-wrapper{\r\n  padding: 1%;\r\n  margin: 1%;\r\n}\r\n::ng-deep.mat-selection_label .mat-form-field-label-wrapper{\r\n  position: absolute !important;\r\n  top: 1px !important;\r\n}\r\n::ng-deep.mat-selection_label  .mat-form-field-infix{\r\n  border: 0 !important;\r\n  height: 33px !important;\r\n  font-size: 13px;\r\n}\r\n::ng-deep.selection_label .mat-form-field-appearance-outline .mat-form-field-wrapper{\r\n  padding: 1%;\r\n  margin: 1%;\r\n}\r\n\r\n::ng-deep.selection_label  .mat-select-trigger {\r\n  min-width: 10vw;\r\n}\r\n::ng-deep.path_class{\r\n    width: 100%;\r\n    // margin-top: 1%;\r\n}\r\n\r\n::ng-deep.pushmodal .modal-dialog {\r\n  max-width:50%!important;\r\n  max-height: 60%!important;\r\n  height: 60%!important;\r\n  margin: auto!important;\r\n  padding: 0 !important;\r\n}\r\n::ng-deep.pushmodal{\r\n  top: 4%!important;\r\n}\r\n\r\n.ellipsisfull{\r\n  white-space: nowrap;\r\n  overflow: hidden;\r\n  text-overflow: ellipsis;\r\n  /* width: 100% !important; */\r\n  max-width: 90%;\r\n}\r\n\r\n::ng-deep .field_droping .mat-form-field-appearance-outline.mat-form-field-can-float.mat-form-field-should-float .mat-form-field-label{\r\n  margin-left: 8px !important;\r\n}\r\n\r\n::ng-deep .field_droping .mat-form-field-appearance-outline .mat-form-field-infix{\r\n  padding: 3px 7px !important;\r\n}\r\n\r\n\r\n::ng-deep.Version_dropDowns .mat-form-field-wrapper .mat-form-field-flex .mat-form-field-infix .mat-select .mat-select-trigger .mat-select-value{\r\n  width: 65% !important;\r\n}\r\n.Version_dropDowns{\r\n  height: 32px;\r\n  border-radius: 5px;\r\n  position: relative;\r\n  top: -7px;\r\n  background-color: white;\r\n  margin-block: 1%;\r\n  padding-left: 5px;\r\n  width: 60%;\r\n}\r\n::ng-deep.Version_dropDowns  .mat-form-field-infix{\r\n  border: 0 !important;\r\n  height: 33px !important;\r\n  font-size: 13px;\r\n}\r\n::ng-deep.Version_dropDowns .mat-form-field-appearance-outline .mat-form-field-wrapper{\r\n  padding: 1%;\r\n  margin: 1%;\r\n}\r\n::ng-deep.Version_dropDowns .mat-form-field-label-wrapper{\r\n  top:-1px !important;\r\n}\r\n::ng-deep.Version_dropDowns  .mat-select-trigger {\r\n  min-width: 13vw !important;\r\n}\r\n::ng-deep.Version_dropDowns  .mat-select-arrow {\r\n  position: relative !important;\r\n  right: 47% !important;\r\n}\r\n\r\n\r\n::ng-deep.myCustomModalViewfilehl7Viewer .modal-dialog {\r\n  max-width: 80% !important;\r\n  max-height: 60% !important;\r\n  height: 60% !important;\r\n  padding: 0 !important;\r\n  display: flex !important;justify-content: center !important;\r\n}\r\n::ng-deep.matoutlinestyles.versionfield\r\n{\r\n  width: 70% !important;\r\n  .mat-mdc-text-field-wrapper{\r\n    padding-block: 0px !important;\r\n  }\r\n}\r\n\r\n::ng-deep .rule-engine-tabs.mat-mdc-tab-group.mat-mdc-tab-group-stretch-tabs > .mat-mdc-tab-header .mat-mdc-tab {\r\n    flex-grow: 0;\r\n  }\r\n  \r\n \r\n  ::ng-deep .rule-engine-tabs .mat-mdc-tab {\r\n    background-color: white;\r\n  }\r\n  \r\n  ::ng-deep .rule-engine-tabs .mat-mdc-tab.mat-mdc-tab-active {\r\n    background-color: white;\r\n  }\r\n  \r\n  ::ng-deep .rule-engine-tabs .mat-mdc-tab-label-container {\r\n    background-color: white !important;\r\n  }\r\n\r\n.qualified-routes-list {\r\n  margin-top: 20px;\r\n}\r\n\r\n.qualified-routes-list ul {\r\n  list-style-type: none;\r\n  padding: 0;\r\n}\r\n\r\n.qualified-routes-list .route-item {\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: space-between;\r\n  padding: 5px 10px;\r\n  border: 1px solid #ccc;\r\n  border-radius: 4px;\r\n  margin-bottom: 5px;\r\n}\r\n\r\n.qualified-routes-list .route-item:hover {\r\n  background-color: #e3eaec;\r\n}\r\n\r\n.scrollable-output {\r\n  overflow-y: auto; \r\n  height: 52vh; \r\n  width: 90vh;\r\n  padding-right: 10px; \r\n  font-size: 12px;\r\n  margin-top: 25px;\r\n}\r\n.scrollable-routes {\r\n  overflow-y: auto; \r\n  padding: 10px; \r\n}\r\n\r\n.Ruleengineasterisk{\r\n  font-size: 7px;\r\n  position: absolute;\r\n  color: #f44455c4 !important;\r\n}","$btn-color: #17a0b4 !important;\r\n$fontsize: 12px !important;\r\n$btntextcolor: white !important;\r\n$btnHeight: 28px !important;\r\n$inputHeight:30px !important;\r\n$inputfontsize:11px !important;\r\n$primary:#004bff;\r\n// $modalHeaderTitleFont: ;\r\n@mixin modalheaderTtext {\r\n  font-size: 14px;\r\n  font-weight: 600;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
